/**
 * CollectorEdit (Atelier Theme) Product Accordion
 * - Renames tabs: Description | Condition | Size & Measurements | Shipping & Returns
 * - Parses and cleans the raw product description
 * - Shows AI description at the top of Description tab if present
 * - collectoredit.com
 */
(function () {
  'use strict';

  // ── SKIP PATTERNS (lines to remove entirely) ────────────────────────────
  const SKIP_PATTERNS = [
    /^\*please allow/i,
    /^\*measurements are taken/i,
    /^\*if the stated size/i,
    /^\*materials may be listed/i,
    /^\*as this is a used item/i,
    /^\*depending on the item/i,
    /^\*we use.*grid sheet/i,
    /^the actual size may differ/i,
    /^about size$/i,
    /^please read and understand/i,
    /^please note that we sell/i,
    /^the box in the picture/i,
    /^the item is purchased from/i,
    /^all sales are final/i,
    /^most items.*are preloved/i,
    /^preloved items may have odor/i,
    /^all of our items undergo/i,
    /^the color in the photo may be different/i,
    /^please look at photos and read/i,
    /^□+$/,
    /^-+$/,
    /^item name$/i,
    /^item name\s+/i,
    /^measurements are taken/i,
    /^when the size.*is not indicated/i,
    /^actual size may differ/i,
    /^please note that depending/i,
    /^please note that these shoes are pre-owned/i,
    /^since this is clothing/i,
    /^please be aware that there may be slight fraying/i,
    /^although the actual size is shown/i,
    /^there may be slight errors/i,
    /^if you have any questions regarding size/i,
    /^please feel free to contact us/i,
    /^\*?please see below for rank details/i,
    /^engraving\s*:/i,
    /^engraved\s*:/i,
    /^made in \d{4}/i,
    /^\[engraving\]/i,
    /^[•\-]\s*notes?\s*:\s*$/i,
    /^there are no accessories other than/i,
    /^detail remarks\s*:/i,
    /^\[?condition\s*rank\]?\.?\s*$/i,
    /^details?\s*:/i,
    /^comments?\s*:/i,
    /^about\s+us\s*[-:]/i,
    /^description\s*[;:]/i,
    /^(but\.?\s*)?(however\.?\s*)?(it\s+)?can\s+still\s+be\s+used/i,
    /^(but|however)\.?\s*(it\s+)?(is\s+)?(still\s+)?(usable|functional|works?)/i,
    /can\s+still\s+be\s+used/i,
    /^the color may look different depending on/i,
    /^the items shown in the images are all that are included/i,
    /^scheduled delivery/i,
    /^sagawa express/i,
    /^hikyaku courier/i,
    /^\d+\s*size\s*\*?customers/i,
    /^customers cannot specify/i,
    /^we will ship within/i,
    /^ship within \d+ business days/i,
    /^excluding weekends and holidays/i,
    /^after payment/i,
    /^delivery method/i,
    /^delivery company/i,
    /^yamato transport/i,
    /^japan post/i,
    /^kuroneko/i,
    /^S\s*:\s*(almost|nearly|new|unused|mint|the\s+item|item\s+shows|item\s+is)/i,
    /^A\s*:\s*(it\s+is|very\s+good|excellent|good\s+condition|in\s+very\s+good|item\s+has|the\s+item|item\s+is)/i,
    /^B\s*:\s*(there\s+are|some\s+signs|moderate|used|normal|item\s+with|the\s+item|item\s+has|item\s+is)/i,
    /^C\s*:\s*(in\s+addition|noticeable|significant|heavy|well\s+used|item\s+with|the\s+item|item\s+has)/i,
    /^D\s*:\s*(poor|damaged|junk|for\s+parts|item\s+is|the\s+item)/i,
    /^N\s*:\s*(new|unused|brand\s+new|item\s+is|the\s+item)/i,
    /^[SABCDN]\s*:\s*(?:the\s+)?item\s+(?:shows?|has|is|with)\s/i,
    /^SA\s*:\s*/i,
    /^AB\s*:\s*/i,
    /^BC\s*:\s*/i,
    /^about\s+condition\s+rank/i,
    /^condition\s+rank\s*:/i,
    /^rank\s+explanation/i,
    /^rank\s+guide/i,
    /^remarks?\s*$/i,
    /^remarks?\s*:\s*$/i,
    /^condition\s*-?\s*$/i,
    /^-?\s*condition\s*-?\s*$/i,
    /^reference\s+price\s*:\s*-?\s*$/i,
    /^this is a [a-z]+ [a-z]+.*muffler/i,
    /^made of high.quality/i,
    /^be sure to use it/i,
    /^recommended scenes?\s*-?\s*$/i,
    /^recommended scenes?\s*-/i,
    /^the calm .* color goes/i,
    /^due to the universal design/i,
    /^it is perfect for pairing/i,
    /^it has a soft texture/i,
    /^will brighten up your/i,
    /^please check the posted photos/i,
    /^\*?this is a used item/i,
    /^please note that since we are dealing with used items/i,
    /^we are unable to fully grasp/i,
    /^although there are some scratches/i,
    /^this item has little signs of use/i,
    /please\s+check\s+(the\s+)?(condition|photos?)/i,
    /there\s+is\s+no\s+other\s+damage/i,
    /the\s+item\s+can\s+be\s+used/i,
    /before\s+considering\s+purchas/i,
    /^-?\s*color\s*-?\s*$/i,
    /^\[gray-?\]\s*$/i,
    /^\(?\s*(see\s+)?(photo|image)s?\s*\)?\.?$/i,
    /^refer\s+to\s+(photo|image)/i,
    /^see\s+attached\s+(photo|image)/i,
    /^material\s*:\s*(see\s+)?(photo|image)/i,
    /^color\s*:\s*(see\s+)?(photo|image)/i,
    /^\[.*-\]\s*$/i,
    // Plain junk values that appear after bracket labels
    /^ladies\s*$/i,
    /^men('?s)?\s*$/i,
    /^unisex\s*$/i,
    /^used item [a-zA-Z]\+?\s*$/i,
    /^rank [a-zA-Z]\s*$/i,
    /^[a-d]\s*rank\s*$/i,
    /^no\s+accessories?\s*$/i,
    /^none\s*$/i,
    /^n\/a\s*$/i,
    // AUTHENTICITY GUARANTEE boilerplate
    /^AUTHENTICITY GUARANTEE/i,
    /^All The Reluxe items are carefully/i,
  ];

  // Fields to completely skip (not useful to customer)
  const SKIP_FIELDS = new Set([
    'brand', 'name', 'common name', 'product number', 'management number',
    'control number', 'category', 'reference price', 'product name',
    'item name', 'remarks', 'shape number and item number',
  ]);

  // Fields → Description tab
  const DESC_FIELDS = new Set([
    'material', 'materials', 'outer material', 'lining material',
    'lining', 'hardware', 'clasp', 'closure', 'color', 'colour',
    'accessories', 'series', 'model', 'model name', 'model number',
    'model type', 'line', 'model line', 'country of origin', 'made in',
    'weight', 'features', 'style', 'pattern',
  ]);

  // Fields → Condition tab
  const CONDITION_FIELDS = new Set([
    'condition', 'item rank', 'rank', 'item condition', 'damage',
    'damage details', 'scratches', 'wear', 'stain', 'stains',
    'dirt', 'odor', 'smell', 'fading', 'discoloration', 'scuff',
    'scuffs', 'tear', 'crack', 'peeling', 'tarnish', 'defect',
    'flaws', 'detail remarks', 'overall condition',
  ]);

  // Fields → Size tab
  const SIZE_FIELDS = new Set([
    'size', 'measurement', 'measurements', 'dimensions', 'dimension',
    'width', 'height', 'depth', 'length', 'strap', 'strap length',
    'handle', 'handle drop', 'handle length', 'circumference',
    'diameter', 'chest', 'waist', 'shoulder', 'shoulder width',
    'sleeve', 'sleeve length', 'inseam', 'rise', 'hip', 'bust',
    'notation size', 'size indicated', 'actual size', 'reference size',
  ]);

  // Shipping & Returns static HTML
  const SHIPPING_HTML = `
    <div style="line-height: 1.8; font-size: inherit;">
      <p><strong>Handling Time</strong><br>
      2-3 business days
    <p><strong>US</strong><br>
      Free standard shipping on all orders over $500. Express options available at checkout.</p>
      <p><strong>Canada</strong><br>
      Flat rate shipping. Duties and taxes may apply upon delivery.</p>
      <p><strong>International</strong><br>
      We ship worldwide. Shipping rates calculated at checkout. Import duties and taxes are the buyer's responsibility.</p>
      <p><strong>Returns</strong><br>
      We accept returns within 3 days of delivery. Items must be in the same condition as received. Contact us before returning any item.</p>
    </div>
  `;

  // ── PARSER ──────────────────────────────────────────────────────────────

  function htmlToLines(html) {
    return html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p\s*>/gi, '\n')
      .replace(/<p[^>]*>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;|&apos;/g, "'")
      .replace(/&nbsp;/g, ' ')
      .split('\n')
      .map(l => l.trim())
      .filter(l => l.length > 0);
  }

  function shouldSkip(line) {
    return SKIP_PATTERNS.some(p => p.test(line));
  }

  // Detect "[Field Name]" bracket label
  function parseBracket(line) {
    const m = line.match(/^\[([^\]]{1,50})\]\s*(.*)$/);
    if (!m) return null;
    return { field: m[1].toLowerCase().trim(), value: m[2].trim() };
  }

  // Detect "Field Name: value" or "Field Name:" colon label
  function parseColon(line) {
    const m = line.match(/^([A-Za-z][A-Za-z\s&\/\-]{0,40}):\s*(.*)/);
    if (!m) return null;
    return { field: m[1].toLowerCase().trim(), value: m[2].trim() };
  }

  // Detect a measurement line: contains digits + cm/in/mm or x/× separators
  function isMeasurementLine(line) {
    return /\d+(\.\d+)?\s*(cm|in|mm)\b/i.test(line) ||
           /\d+\s*(x|×|\*)\s*\d+/i.test(line);
  }

  function toLabel(field) {
    return field.replace(/\b\w/g, c => c.toUpperCase());
  }

  function classifyField(fieldName) {
    if (SKIP_FIELDS.has(fieldName)) return 'skip';
    if (DESC_FIELDS.has(fieldName)) return 'desc';
    if (CONDITION_FIELDS.has(fieldName)) return 'condition';
    if (SIZE_FIELDS.has(fieldName)) return 'size';
    // Partial match
    for (const f of DESC_FIELDS) if (fieldName.includes(f) || f.includes(fieldName)) return 'desc';
    for (const f of CONDITION_FIELDS) if (fieldName.includes(f) || f.includes(fieldName)) return 'condition';
    for (const f of SIZE_FIELDS) if (fieldName.includes(f) || f.includes(fieldName)) return 'size';
    return 'skip';
  }

  function parseDescription(html) {
    const lines = htmlToLines(html);
    const data = { desc: [], condition: [], size: [] };

    let i = 0;
    while (i < lines.length) {
      const line = lines[i];
      i++;

      if (shouldSkip(line)) continue;

      // Try bracket label: [Field]
      const bracket = parseBracket(line);
      if (bracket) {
        const tab = classifyField(bracket.field);
        if (tab === 'skip') {
          // Skip the value line(s) too if bracket had no inline value
          if (!bracket.value && i < lines.length && !parseBracket(lines[i]) && !parseColon(lines[i])) i++;
          continue;
        }
        let value = bracket.value;
        // Value may be on the next line
        if (!value && i < lines.length) {
          const next = lines[i];
          if (!parseBracket(next) && !parseColon(next) && !shouldSkip(next)) {
            value = next;
            i++;
          }
        }
        if (value && !shouldSkip(value)) {
          data[tab].push({ field: toLabel(bracket.field), value });
        }
        continue;
      }

      // Try colon label: Field: value
      const colon = parseColon(line);
      if (colon) {
        const tab = classifyField(colon.field);
        if (tab === 'skip') continue;
        let value = colon.value;
        // Value may continue on next line(s) (e.g. Size: with multiple measurement lines)
        if (tab === 'size') {
          // Collect all following measurement/plain lines until next label
          const sizeLines = value ? [value] : [];
          while (i < lines.length) {
            const next = lines[i];
            if (parseBracket(next) || parseColon(next)) break;
            if (shouldSkip(next)) { i++; continue; }
            sizeLines.push(next);
            i++;
          }
          if (sizeLines.length > 0) {
            data.size.push({ field: toLabel(colon.field), value: sizeLines.join(' / ') });
          }
          continue;
        }
        // For non-size fields, grab next line if no inline value
        if (!value && i < lines.length) {
          const next = lines[i];
          if (!parseBracket(next) && !parseColon(next) && !shouldSkip(next)) {
            value = next;
            i++;
          }
        }
        if (value && !shouldSkip(value)) {
          data[tab].push({ field: toLabel(colon.field), value });
        }
        continue;
      }

      // Plain line with no label — check if it's a measurement
      if (isMeasurementLine(line)) {
        data.size.push({ field: null, value: line });
        continue;
      }

      // Everything else: skip (usually translated junk)
    }

    return data;
  }

  // ── HTML BUILDERS ────────────────────────────────────────────────────────

  function buildDescriptionHTML(data, aiDescription) {
    let html = '';
    if (aiDescription) {
      html += `<div style="margin-bottom: 18px; line-height: 1.8;">${aiDescription}</div>`;
    }
    if (data.desc.length > 0) {
      const rows = data.desc
        .map(({ field, value }) => `<span><strong>${field}:</strong> ${escHtml(value)}</span>`)
        .join('<br>');
      html += `<div style="line-height: 1.9;">${rows}</div>`;
    }
    return html || '<p style="color: #888; font-style: italic;">See product images for details.</p>';
  }

const CONDITION_GUIDE_HTML = `
  <hr style="margin: 24px 0; opacity: 0.2;">
  <p style="font-size: 0.78em; text-transform: uppercase; letter-spacing: 0.12em; margin-bottom: 14px; opacity: 0.5;">Condition Guide</p>
  <div style="line-height: 1.9; font-size: 0.9em;">
    <p style="margin-bottom: 10px;">Most items in the Collector Edit catalog are pre-owned. Each piece is personally inspected and rated honestly — we always err on the side of over-disclosing. Review the detailed listing photos alongside the rating for the fullest picture.</p>
    <p><strong>New / Unworn</strong> — No signs of use. May include original tags, dustbag, box, or documentation. Sourced from retail or a private collection and never carried.</p>
    <p><strong>Pristine</strong> — Essentially indistinguishable from new, with no marks, scuffs, or wear. May have been briefly handled or tried on. Hardware is bright and leather is fully unmarked.</p>
    <p><strong>Excellent</strong> — Carried very lightly, with any signs of handling only visible under close inspection. A standout condition for a pre-owned piece.</p>
    <p><strong>Very Good</strong> — Gently used with minor visible wear consistent with careful ownership — think faint surface marks, light corner wear, or subtle leather softening. Nothing that affects beauty or function.</p>
    <p><strong>Good</strong> — Regularly carried with honest, visible signs of use. May include surface scratches, light patina on handles, or minor hardware tarnish. All specific flaws are noted in the listing.</p>
    <p><strong>Fair</strong> — Noticeably worn with moderate to significant signs of use. Ideal for everyday use, restoration, or collectors focused on authenticity over cosmetics. All flaws fully disclosed.</p>
  </div>
`;

function buildConditionHTML(data) {
  let itemCondition = '';
  if (data.condition.length === 0) {
    itemCondition = '<p style="color: #888; font-style: italic;">Please refer to product images for condition details.</p>';
  } else {
    const rows = data.condition
      .map(({ field, value }) =>
        field ? `<span><strong>${field}:</strong> ${escHtml(value)}</span>` : `<span>${escHtml(value)}</span>`
      )
      .join('<br>');
    itemCondition = `<div style="line-height: 1.9;">${rows}</div>`;
  }
  return itemCondition + CONDITION_GUIDE_HTML;
}

  function buildSizeHTML(data) {
    if (data.size.length === 0) {
      return '<p style="color: #888; font-style: italic;">Please refer to product images for measurements.</p>';
    }
    const rows = data.size
      .map(({ field, value }) =>
        field ? `<span><strong>${field}:</strong> ${escHtml(value)}</span>` : `<span>${escHtml(value)}</span>`
      )
      .join('<br>');
    return `<div style="line-height: 1.9;">${rows}</div>`;
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // ── DOM HELPERS ──────────────────────────────────────────────────────────

  function setSummaryText(tabEl, text) {
    const summary = tabEl.querySelector('summary.details__header');
    if (!summary) return;
    // The label is a raw text node — find and replace it
    for (const node of summary.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = '\n      ' + text + '\n      ';
        return;
      }
    }
  }

  function setTabContent(tabEl, html) {
    const content = tabEl.querySelector('.details-content');
    if (!content) return;
    // Replace the inner text-block div, preserving wrapper
    const textBlock = content.querySelector('.text-block, .spacing-style');
    if (textBlock) {
      textBlock.innerHTML = html;
    } else {
      content.innerHTML = `<div style="padding-top: 12px;">${html}</div>`;
    }
  }

  function cloneTabWithContent(templateEl, labelText, contentHTML) {
    const clone = templateEl.cloneNode(true);
    // Ensure it starts closed
    const details = clone.querySelector('details');
    if (details) details.removeAttribute('open');
    setSummaryText(clone, labelText);
    setTabContent(clone, contentHTML);
    return clone;
  }

  // ── INIT ─────────────────────────────────────────────────────────────────

  function init() {
    if (!window.location.pathname.includes('/products/')) return;

    // Atelier renders multiple .accordion wrappers; find the one with accordion-custom tabs
    const wrapper = Array.from(document.querySelectorAll('.accordion')).find(
      el => el.querySelector('accordion-custom')
    );
    if (!wrapper) return;
    if (wrapper.dataset.ceInit) return;
    wrapper.dataset.ceInit = '1';

    const tabs = Array.from(wrapper.querySelectorAll('accordion-custom'));
    if (tabs.length < 1) return;

    // ── Parse description from Tab 1 ────────────────────────────────────
    const descTabEl = tabs[0];
    const descContent = descTabEl.querySelector('.details-content');
    if (!descContent) return;

    // Extract AI description metafield if present
    const aiDescEl = descContent.querySelector('[data-ai-description]');
    let aiDescription = null;
    if (aiDescEl) {
      aiDescription = aiDescEl.innerHTML.trim();
      aiDescEl.remove();
    }

    const rawHTML = descContent.innerHTML;
    const data = parseDescription(rawHTML);

    // ── Tab 1: Description ───────────────────────────────────────────────
    setSummaryText(tabs[0], 'Description');
    setTabContent(tabs[0], buildDescriptionHTML(data, aiDescription));

    // ── Tab 2: Condition & Guide (was "Care") ────────────────────────────────────
    if (tabs[1]) {
      setSummaryText(tabs[1], 'Condition / Guide');
      setTabContent(tabs[1], buildConditionHTML(data));
    }

    // ── Tab 3: Size / Measurements (was "Design") ────────────────────────
    if (tabs[2]) {
      setSummaryText(tabs[2], 'Size');
      setTabContent(tabs[2], buildSizeHTML(data));
    }

    // ── Tab 4: Shipping / Returns (new) ──────────────────────────────────
    const template = tabs[tabs.length - 1];
    const shippingTab = cloneTabWithContent(template, 'Shipping / Returns', SHIPPING_HTML);
    wrapper.appendChild(shippingTab);

    console.log('[CE Accordion] Initialized — desc:', data.desc.length, 'condition:', data.condition.length, 'size:', data.size.length);
  }

  // Run on product pages
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
